// The "1 Fecha · 2 Entradas · 3 Pago · 4 Listo" progress chip shown in the
// shell header during the buying flow. Numbers always show; labels appear on
// wide screens (the 21" tótem has room).

import { Fragment } from "react";
import { useLang } from "../i18n/LangContext";
import type { StringKey } from "../i18n/strings";

const STEPS: { num: number; key: StringKey }[] = [
  { num: 1, key: "stepDate" },
  { num: 2, key: "stepTickets" },
  { num: 3, key: "stepPayment" },
  { num: 4, key: "stepDone" },
];

function pillModifier(num: number, current: number): string {
  if (num < current) {
    return "step-pill--done";
  }
  if (num === current) {
    return "step-pill--active";
  }
  return "";
}

export function StepIndicator({ current }: { current: number }) {
  const { t } = useLang();
  return (
    <div className="step-pills">
      {STEPS.map((step, i) => (
        <Fragment key={step.num}>
          {i > 0 ? <span className="step-pill__sep" /> : null}
          <span
            className={["step-pill", pillModifier(step.num, current)]
              .filter(Boolean)
              .join(" ")}
          >
            <span className="step-pill__num">{step.num}</span>
            <span className="step-pill__label">{t(step.key)}</span>
          </span>
        </Fragment>
      ))}
    </div>
  );
}
